export const sideNavbar = {
  home: "Início",
  games: "Slots",
  allGames: "Jogos",
  lottery: "Loteria",
  raffle: "Rifa",
  providers: "Escolha seu provedor favorito",
  categories: "Categorias",
  casino: "Cassino ao vivo",
  casinos: "Cassino ao vivo",
  poker: "Pôquer",
  sports: "Esportes",
  allSports: "Esportes",
  soccer: "Futebol",
  baseball: "Beisebol",
  basketball: "Basquete",
  e_sports: "E-Sports",
  nfl: "NFL",
  allPageSports: "Ver todos",
  parleyMenu: "Múltiplas",
  allPageGames: "Ver todos",
  support: "Suporte",
  live_casino: "Cassino ao vivo",
  bingo: "Bingo",
  horses: "Cavalos",
  hipism: "Turfe",
  News: "Notícias",
  gameFeed: "Feed de jogos",
  miniJuegos: "Minijogos",
  winnerTestimonials: "Depoimentos",
  sidebarSectionMain: "PRINCIPAL",
  sidebarSectionGames: "JOGOS",
  sidebarSectionMore: "MAIS",
  sidebarSectionActions: "AÇÕES",
  sidebarMyFavorites: "Meus favoritos",
};
